import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PendingActionItems = ({ data: liveData }) => {
  const navigate = useNavigate();

  const mockPendingItems = [
    { id: 1, title: 'Approve Leave Requests', description: '5 pending leave requests require approval', priority: 'high', dueDate: 'Today', action: 'Review', icon: 'Clock', route: '/erp/employee-management' },
    { id: 2, title: 'Process Payroll', description: 'July 2025 payroll processing pending', priority: 'high', dueDate: 'Tomorrow', action: 'Process', icon: 'Banknote', route: '/erp/payroll-management' }
  ];

  const pendingItems = (liveData && liveData.length > 0) ? liveData : mockPendingItems;

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-error bg-error/10 border-error/20';
      case 'medium':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'low':
        return 'text-success bg-success/10 border-success/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const handleActionClick = (item) => {
    if (item.route) {
        navigate(item.route);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Pending Actions</h3>
          <p className="text-sm text-muted-foreground">Items requiring your attention</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">
            {pendingItems.filter(item => item.priority === 'high').length} High Priority
          </span>
        </div>
      </div>

      <div className="space-y-3">
        {pendingItems.map((item) => (
          <div key={item.id} className="flex items-center gap-4 p-4 border border-border rounded-lg hover:bg-muted/50 transition-colors duration-200">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
                <Icon name={item.icon} size={18} className="text-muted-foreground" />
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <h4 className="text-sm font-medium text-foreground truncate">
                  {item.title}
                </h4>
                <span className={`px-2 py-1 text-xs font-medium rounded-full border ${getPriorityColor(item.priority)}`}>
                  {item.priority.toUpperCase()}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-2 line-clamp-1">
                {item.description}
              </p>
              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="Calendar" size={12} />
                  Due: {item.dueDate}
                </span>
              </div>
            </div>

            <div className="flex-shrink-0">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleActionClick(item)}
                className="text-xs"
              >
                {item.action}
              </Button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            {pendingItems.length} total pending items
          </span>
          <Button variant="ghost" size="sm" className="text-primary">
            <Icon name="ArrowRight" size={16} className="mr-1" />
            View All Tasks
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PendingActionItems;